import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import { getTimezone, MANAGER_TIMEZONE } from "./timezone";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

type ReportDateRangeParams = {
    startDate?: Dayjs | null;
    endDate?: Dayjs | null;
    isManager: boolean;
    authenticatedCustomerUtcZone?: string | null;
};

export type ReportDateRangeMillis = {
    startDate: number | null;
    endDate: number | null;
};

type ReportTimezoneParams = Pick<
    ReportDateRangeParams,
    "isManager" | "authenticatedCustomerUtcZone"
>;

export const getReportTimezone = ({
    isManager,
    authenticatedCustomerUtcZone,
}: ReportTimezoneParams): string => {
    return isManager
        ? MANAGER_TIMEZONE
        : getTimezone(authenticatedCustomerUtcZone);
};

const toReportTimezoneMillis = (
    value: Dayjs | null | undefined,
    timezone: string,
): number | null => {
    if (!value?.isValid()) {
        return null;
    }

    return dayjs
        .tz(value.format("YYYY-MM-DD HH:mm:ss.SSS"), timezone)
        .valueOf();
};

export const getReportDateRangeMillis = ({
    startDate,
    endDate,
    isManager,
    authenticatedCustomerUtcZone,
}: ReportDateRangeParams): ReportDateRangeMillis => {
    const timezone = getReportTimezone({
        isManager,
        authenticatedCustomerUtcZone,
    });

    return {
        startDate: toReportTimezoneMillis(startDate, timezone),
        endDate: toReportTimezoneMillis(endDate, timezone),
    };
};
